import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const whiteRoundedBg = css`
  background-color: ${theme.colors.white};
  border-radius: ${theme.borderRadius.small};
  padding: ${theme.spacing(3, 5)};
  display: inherit;
  overflow: hidden auto;
`;

export const alignVertical = css`
  display: flex;
  flex-direction: column;
`;

export const alignHorizontal = css`
  display: flex;
  flex-direction: row;
`;
export const alignItemsCenter = css`
  align-items: center;
`;

export const sectionTitle = css`
  font-size: ${theme.fontSize(20)};
  color: ${theme.colors.neutral90};
`;

export const sectionContent = css`
  font-size: ${theme.fontSize(20)};
  color: ${theme.colors.neutral80};
  font-weight: ${theme.font.weight.bold};
`;

export const infoTitle = css`
  font-size: ${theme.fontSize(12)};
  color: ${theme.colors.neutral50};
`;

export const flexRowWrapItems = css`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
`;
